import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner } from 'react-bootstrap';
import '../../styles/Dashboard.css';
import AttendanceTable from '../../components/AttendanceTable';
import AttendanceCard from '../../components/AttendanceCards';
import AttendanceCardWeek from '../../components/AttendanceCardsWeek';
import AttendanceCardMonth from '../../components/AttendanceCardsMonth';
import EmployeeInfoCard from '../../components/EmployeeInfoCard';
import useAuth from '../../pages/useAuth';

const UserInternal_Dashboard = () => {
     useAuth();
     const baseUrl = process.env.REACT_APP_BASE_URL;

     const [attendanceData, setAttendanceData] = useState(null);
     const [loading, setLoading] = useState(true);

     const [currentEmployee, setCurrentEmployee] = useState({
          photo: 'https://randomuser.me/api/portraits/men/32.jpg',
          name: '',
          id: ''
     });

     useEffect(() => {
          // ✅ Load user info instantly from sessionStorage
          const userCode = sessionStorage.getItem('user_code');
          const userName = sessionStorage.getItem('user_name');
          setCurrentEmployee((prev) => ({
               ...prev,
               name: userName,
               id: userCode
          }));
     }, []);

     useEffect(() => {
          const fetchAttendance = async () => {
               try {
                    setLoading(true);
                    const response = await fetch(`${baseUrl}/getUserAttendance`, {
                         method: "GET",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${sessionStorage.getItem("token")}`
                         },
                    });

                    const data = await response.json();
                    if (data.status) {
                         setAttendanceData(data.data);
                    }
               } catch (error) {
                    console.error("Error fetching attendance:", error);
               } finally {
                    setLoading(false);
               }
          };

          fetchAttendance();
     }, [baseUrl]);

     // fallback values until data is loaded
     const todayPunchIn = attendanceData?.today?.punch_in || "-";
     const todayPunchOut = attendanceData?.today?.punch_out || "-";
     const weekPresent = attendanceData?.this_week?.present_days ?? 0;
     const weekAbsent = attendanceData?.this_week?.absent_days ?? 0;
     const monthPresent = attendanceData?.this_month?.present_days ?? 0;
     const monthAbsent = attendanceData?.this_month?.absent_days ?? 0;

     const summaryData = [
          { label: 'Present', value: attendanceData?.summary?.present ?? 0, color: 'success' },
          { label: 'Not Present', value: attendanceData?.summary?.absent ?? 0, color: 'danger' },
          { label: 'Away', value: attendanceData?.summary?.away ?? 0, color: 'warning' },
          { label: 'Overtime', value: attendanceData?.summary?.overtime ?? 0, color: 'info' }
     ];

     const attendanceRecords = attendanceData?.records || [];

     return (
          <div className="dashboard-page">
               {/* Top Section with Employee Info and Attendance Cards */}
               <Row className="mb-4">
                    <Col md={3}>
                         <EmployeeInfoCard employee={currentEmployee} />
                    </Col>
                    <Col md={9}>
                         <div
                              style={{
                                   display: "flex",
                                   flexWrap: "wrap",
                                   gap: "16px",
                                   justifyContent: "space-between"
                              }}
                         >
                              <div style={{ flex: "1 1 calc(33% - 16px)", minWidth: "250px" }}>
                                   <AttendanceCard
                                        title="Today's Attendance"
                                        present={todayPunchIn}
                                        absent={todayPunchOut}
                                   />
                              </div>

                              <div style={{ flex: "1 1 calc(33% - 16px)", minWidth: "250px" }}>
                                   <AttendanceCardWeek
                                        title="This Week"
                                        present={weekPresent}
                                        absent={weekAbsent}
                                   />
                              </div>

                              <div style={{ flex: "1 1 calc(33% - 16px)", minWidth: "250px" }}>
                                   <AttendanceCardMonth
                                        title="This Month"
                                        present={monthPresent}
                                        absent={monthAbsent}
                                   />
                              </div>
                         </div>
                    </Col>
               </Row>

               <h2>Today's Attendance Overview</h2>
               <Row className="mb-4">
                    {summaryData.map((item, idx) => (
                         <Col key={idx} md={3}>
                              <Card className="summary-card">
                                   <Card.Body>
                                        <Card.Title>{item.label}</Card.Title>
                                        {loading ? (
                                             <Spinner animation="border" size="sm" />
                                        ) : (
                                             <Card.Text className={`text-${item.color}`}>
                                                  {item.value}
                                             </Card.Text>
                                        )}
                                   </Card.Body>
                              </Card>
                         </Col>
                    ))}
               </Row>

               <Card>
                    <Card.Header>Detailed Employee Attendance</Card.Header>
                    {loading ? (
                         <div style={{ padding: "20px", textAlign: "center" }}>
                              <Spinner animation="border" />
                              <p>Loading attendance...</p>
                         </div>
                    ) : (
                         <AttendanceTable records={attendanceRecords} />
                    )}
               </Card>
          </div>
     );
};

export default UserInternal_Dashboard;
